/**
 * Shared world-region enum - mirrors the backend's `common/constants/
 * world-regions.ts`. Business classification for investor geography
 * preferences and startup HQ (MYN-46, `Country.worldRegion`) - not raw
 * geography data. The former curated `COUNTRIES_BY_REGION` list (~25
 * countries) was retired once the real Country/State/City reference tables
 * landed (`@/api/geography.api`, `Country.worldRegion` field) - country
 * options are now fetched and filtered by `worldRegion` from there instead.
 */
export const WORLD_REGIONS = [
  'North America',
  'Europe',
  'Asia Pacific',
  'Latin America',
  'Middle East & Africa',
] as const;

export type WorldRegion = (typeof WORLD_REGIONS)[number];
